export default __webpack_public_path__ + "static/media/orangearrow.5b982dcc.svg";